/**
 * 配信先グループタブ：一覧 + AI/手動作成。
 * 仕様書: docs/01_spec/spec_mail_system.md B-11
 */
import { Sparkles, UserPlus, Users } from 'lucide-react';
import { useState } from 'react';

import { EmptyState } from '@/components/common/EmptyState';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { useMailGroups } from '@/hooks/useMailGroups';

import { AiGroupingDialog } from './AiGroupingDialog';
import { GroupCard } from './GroupCard';
import { ManualGroupDialog } from './ManualGroupDialog';

export function GroupsTab() {
  const [aiOpen, setAiOpen] = useState(false);
  const [manualOpen, setManualOpen] = useState(false);
  const { data: groups, isLoading } = useMailGroups();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs text-[var(--text-muted)]">
          {isLoading ? '読み込み中…' : `${groups?.length ?? 0} グループ`}
        </div>
        <div className="flex gap-2">
          <Button type="button" variant="secondary" onClick={() => setAiOpen(true)}>
            <Sparkles className="size-4 mr-1" />
            AI で自動グルーピング
          </Button>
          <Button type="button" variant="primary" onClick={() => setManualOpen(true)}>
            <UserPlus className="size-4 mr-1" />
            手動作成
          </Button>
        </div>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center p-12">
          <Spinner />
        </div>
      ) : !groups || groups.length === 0 ? (
        <EmptyState
          icon={Users}
          title="グループがまだ登録されていません"
          description="「AI で自動グルーピング」または「手動作成」から追加できます"
        />
      ) : (
        <div className="space-y-2">
          {groups.map((g) => (
            <GroupCard key={g.id} group={g} />
          ))}
        </div>
      )}

      <AiGroupingDialog open={aiOpen} onOpenChange={setAiOpen} />
      <ManualGroupDialog open={manualOpen} onOpenChange={setManualOpen} />
    </div>
  );
}
